import { render, staticRenderFns } from "./base.vue?vue&type=template&id=0fa60b02&scoped=true&"
import script from "./base.vue?vue&type=script&lang=js&"
export * from "./base.vue?vue&type=script&lang=js&"
import style0 from "./base.vue?vue&type=style&index=0&id=0fa60b02&prod&lang=less&"
import style1 from "./base.vue?vue&type=style&index=1&id=0fa60b02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa60b02",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCookiePanel: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/common/cookiePanel.vue').default})
